import { defer } from "rxjs";
import { finalize, tap } from "rxjs/operators";
export function finalizeWithKind(callback) {
    return (source) => defer(() => {
        let kind = "U";
        return source.pipe(tap({
            complete: () => (kind = "C"),
            error: () => (kind = "E"),
        }), finalize(() => callback(kind)));
    });
}
//# sourceMappingURL=finalizeWithKind.js.map